import { Type } from '@sinclair/typebox';
import { CesgErrorSlug } from '../../errors/cesg.error.js';
import { ErrorSource } from '../standard/error-source.js';
export const NullishType = (...schemas) => Type.Optional(Type.Union([...schemas, Type.Null()]));
export const DateTimeStringType = Type.Union([Type.String(), Type.Date()]);
export const ErrorSchema = Type.Object({
    source: Type.Enum(ErrorSource),
    message: Type.String(),
    slug: NullishType(Type.Enum(CesgErrorSlug)),
});
export const YearMonthDayStringType = Type.String({
    pattern: '^\\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])$',
});
